import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import React, { useState } from "react";
import JsonFormatter from "react-json-formatter";
import CloseIcon from "@mui/icons-material/Close";
import { filterDisplayedKeys, handleTimeKey, translateMessageKey } from "util/messages";

const MessageDetails = ({ message, onClose }) => {
  const { palette } = useTheme();
  const initialState = { open: false, content: null, title: "" };
  const [jsonBox, setJsonBox] = useState(initialState);

  const jsonStyle = {
    propertyStyle: { color: palette.primary.dark },
    stringStyle: { wordBreak: "break-word" },
  };

  const boxStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const resetJsonBox = () => setJsonBox(initialState);

  const JsonFormattedBox = ({ jsonBox, onClose }) => {
    return (
      <Dialog
        open={jsonBox.open}
        onClose={onClose}
        fullWidth={true}
        maxWidth="lg"
      >
        <DialogTitle>
          <Box sx={boxStyle}>
            <Typography variant="h5">{jsonBox.title}</Typography>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ color: palette.primary.light }}>
          <JsonFormatter
            json={jsonBox.content}
            tabWith={4}
            jsonStyle={jsonStyle}
          />
        </DialogContent>
      </Dialog>
    );
  };

  return (
    <Dialog open={!!message} onClose={onClose} fullWidth={true} maxWidth="lg">
      <JsonFormattedBox jsonBox={jsonBox} onClose={resetJsonBox} />
      <DialogTitle>
        <Box sx={boxStyle}>
          <Typography variant="h5">Detalhes da Mensagem</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {filterDisplayedKeys(Object.keys(message)).map((key) => (
            <Box key={key} sx={{ wordWrap: "break-word" }}>
              <strong>{translateMessageKey(key)}:</strong>{" "}
              {handleTimeKey(message, key)}
            </Box>
          ))}
        </DialogContentText>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() =>
              setJsonBox({
                open: true,
                content: message.body,
                title: "Corpo da Mensagem",
              })
            }
          >
            Corpo da Mensagem
          </Button>
          {message.acknowledgement?.message_body ? (
            <Button
              variant="outlined"
              onClick={() =>
                setJsonBox({
                  open: true,
                  content: message.acknowledgement.message_body,
                  title: "Recebimento",
                })
              }
            >
              Recebimento
            </Button>
          ) : null}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default MessageDetails;
